import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface FCRPInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function FCRPInternalControls({ onBack, setActiveSection, controlsListSection }: FCRPInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Financial Closing & Reporting Process"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}
